import React from 'react';
import { graphql } from 'gatsby';
import parse from 'html-react-parser';
import * as styles from './iframe.module.css';

interface Props {
    code: {
        value: string;
    };
    kontentItemId?: string;
}
const IFrame: React.FC<Props> = ({ code, kontentItemId }) => {
    let html = code.value;
    html = html.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
    html = html.replace(/\n/g, '');
    html = html.replace(/&nbsp;([a-zA-Z0-9_-]+)=/g, '$1=');

    html = html.replace(/<iframe(?![^>]*title\s*=)[^>]*>/gi, (match) => {
        if (!match.includes('title=')) {
            return match.replace('>', ' title="Embedded content">');
        }
        return match;
    });

    let processedHtmlTags = parse(html);
    return (
        <div className={styles.reviews} data-kontent-item-id={kontentItemId}>
            {processedHtmlTags}
        </div>
    );
};
export default IFrame;
export const fragmentIFrame = graphql`
    fragment IFrame on kontent_item_component___iframe {
        elements {
            code {
                value
            }
        }
    }
`;
